"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var StepMapper_1 = __importDefault(require("../Wizard/StepMapper"));
var AssignAdmin_1 = __importDefault(require("./AssignAdmin"));
var CreateTeams_1 = __importDefault(require("./CreateTeams"));
var SetMyTeamBase_1 = __importDefault(require("./SetMyTeamBase"));
var WizardParts_1 = require("./WizardParts");
var TEAM_CREATION_STEP_MAPPER = {
    SET_MY_TEAM_BASE: SetMyTeamBase_1.default,
    CREATE_TEAMS: CreateTeams_1.default,
    ASSIGN_LEADS: AssignAdmin_1.default,
};
var TeamCreationSteps = (0, StepMapper_1.default)(TEAM_CREATION_STEP_MAPPER, WizardParts_1.TeamCreationWizardContext);
exports.default = TeamCreationSteps;
